import React from "react";

import { Recipe } from "~types/recipe";

import { RecipeFooterSection } from "@/components/sections/recipe/footer/RecipeFooter";
import { Drawer, SxProps, Theme, useTheme } from "@mui/material";

interface AddToCartDrawerProps {
  isOpen: boolean;
  toggleDrawer: Function;
  recipeData: Pick<Recipe, "pk" | "convenience_level"> | null;
  sx?: SxProps<Theme>;
  aboveDrawer?: boolean; // меняет css под контейнер другого дравера
}

export const AddToCartDrawer = ({
  isOpen,
  toggleDrawer,
  recipeData,
  sx,
  aboveDrawer
}: AddToCartDrawerProps): JSX.Element => {
  const theme = useTheme();

  const setClose = () => {
    toggleDrawer(false);
  };

  return (
    <Drawer
      sx={{ zIndex: aboveDrawer ? 1300 : 0, ...sx }}
      ModalProps={{
        BackdropProps: { invisible: true }
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          maxHeight: theme.variables.vhWithBottomMargin,
          mb: { xs: theme.variables.navBarHeight, md: 0 }
        }
      }}
      onBackdropClick={setClose}
      anchor={"bottom"}
      open={isOpen}
      onClose={setClose}>
      {recipeData && (
        <RecipeFooterSection
          recipeId={recipeData.pk}
          convenienceLevel={recipeData.convenience_level}
          marginBottom={theme.variables.navBarHeight}
          aboveDrawer={aboveDrawer}
        />
      )}
    </Drawer>
  );
};
